module.exports = {"tableConfig":{"columns":[{"header":"DATA","width":"27.5%"},{"header":"HORA","width":"27.5%"},{"header":"STATUS","width":"45%"}]}}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/ec/CarPlateQuery/table/data.json
// module id = 2220
// module chunks = 0